var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-carousel',{attrs:{"interval":5000,"arrow":"never"}},[_c('el-carousel-item',{staticClass:"el-carousel-item"},[_c('page-a')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }